import { RouteRecordRaw } from 'vue-router';
import Search from '@/apps/search/Search.vue';
import { requireSeeker } from '@/router/guards/authGuards';

const searchRoutes: RouteRecordRaw[] = [
  {
    path: '/availability/search',
    name: 'Search',
    component: Search,
    beforeEnter: requireSeeker,
  },
];

export default searchRoutes;
